/**
 * Primary-action styling for the problem authoring surface.
 *
 * These components render under both /admin and /trainer, so the CTA colour has
 * to be one the whole app already uses: #ff5a1f is the orange every other
 * trainer, messaging and student-course CTA uses.
 *
 * Deliberately NOT `bg-primary`. `--primary` flips to near-white under `.dark`
 * (globals.css), and `.dark` is a global, persisted class on <html>
 * (stores/themeStore.ts) — while both the admin and trainer shells paint a light
 * background unconditionally. A token-based button would therefore go
 * white-on-white for anyone who has ever toggled dark mode.
 */
/**
 * `hover:bg-[#ff5a1f]` is not redundant: the shadcn Button default variant
 * carries `hover:bg-primary/90`, which `bg-[#ff5a1f]` alone does not displace
 * (twMerge treats hover:bg-* as its own group). Without it the button reverts to
 * the token on hover — a hue jump in light mode, and near-white in dark.
 */
export const PRIMARY_ACTION = 'bg-[#ff5a1f] text-white hover:bg-[#ff5a1f] hover:opacity-90';
